import { BOX_CLASSNAME } from "@/components/FormField/const";
import { Favorite } from "@/components/Icon/Favorite";
import { usePromotionTag } from "@/lib/preFetch/prefetchPromoTag";
import { useWishlist } from "@/lib/store/wishlist";
import { ChevronDown, ContentLoader, Cross, FormControl, FormField, FormItem, Link, NextImage, PromotionalImage, Select, SelectContent, SelectIcon, SelectItem, SelectTrigger, SelectValue, cn, getPdpPrice, transMoney, useCoordSetAndLook, useCoordSetAndLookProduct, useCoordSetAndLookWishlist, useI18n, } from "@jog/react-components";
import { asImageSrc } from "@prismicio/helpers";
import classNames from "classnames";
const PdpPrice = ({ productData }) => {
    const { currentPrice, originPrice, off } = getPdpPrice(productData);
    const { $t } = useI18n();
    return (<div>
            <div className="flex items-center">
                <div className={classNames("text-[30px] font-bold", off > 0 ? "text-orange-main" : "text-black")}>{`${transMoney(currentPrice)}`}</div>
            </div>
            {off > 0 ? (<div className="mt-1 text-sm text-grey-dark">
                    <div>{$t("Original price: {price}", { price: transMoney(originPrice, false) })}</div>
                </div>) : (<></>)}
        </div>);
};
export const CoordSetAndLookProduct = ({ prismic, ct }) => {
    var _a;
    const { skus, pending } = useCoordSetAndLookProduct({ prismic, ct });
    const { $t } = useI18n();
    const { form } = useCoordSetAndLook();
    const addWishlistItem = useWishlist.use.addWishlistItem();
    const removeWishlistItem = useWishlist.use.removeWishlistItem();
    const simpleWishlist = useWishlist.use.simpleWishlist();
    const { onFavorite, lineItemId } = useCoordSetAndLookWishlist({ addWishlistItem, removeWishlistItem, simpleWishlist }, { prismic, ct });
    const promotionTag = usePromotionTag((_a = ct === null || ct === void 0 ? void 0 : ct.promotionalBanner) === null || _a === void 0 ? void 0 : _a.name);
    return (<div className="grid grid-cols-12 gap-x-4 border-t border-b py-9 lg:gap-x-5 first:lg:border-t-0">
            <div className="relative col-span-4">
                <NextImage className="block h-full w-full object-cover" src={asImageSrc(prismic.cover)} alt={prismic.cover.alt || prismic.name} width={prismic.cover.dimensions.width} height={prismic.cover.dimensions.height}/>
                {promotionTag ? (<PromotionalImage className="absolute -right-1.25 -top-1.25 w-4/12" promotionTag={promotionTag}/>) : (<></>)}
                <Link href={prismic.path} className="absolute inset-0" aria-label={prismic.name}/>
            </div>
            <div className="col-span-8 flex flex-col justify-between">
                <div className="flex flex-col">
                    <p className="text-xl font-semibold uppercase">{prismic.name}</p>
                    {pending ? (<div className="py-4">
                            <ContentLoader className="h-[30px] w-25"/>
                        </div>) : (<div className="mt-1 flex flex-wrap items-center">
                            <PdpPrice productData={ct}/>
                        </div>)}
                </div>
                <div className="mt-4 flex w-full space-x-2">
                    {pending ? (<ContentLoader className="h-[30px] w-full"/>) : (<>
                            <FormField control={form.control} name="products" render={({ field }) => {
                const selectedItem = field.value.find((i) => i.id === ct.id);
                const value = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.sku;
                return (
                // Add key to FormItem to force re-rendering when the value changes
                <FormItem className="flex-1" key={value}>
                                            <Select value={value} onValueChange={(sku) => {
                        if (selectedItem) {
                            selectedItem.sku = sku;
                            field.onChange([...field.value]);
                        }
                        else {
                            field.onChange([...field.value, { id: ct.id, sku }]);
                        }
                    }}>
                                                <div className="relative">
                                                    <FormControl>
                                                        <SelectTrigger className={cn(BOX_CLASSNAME, "z-10 flex h-12 w-full items-center justify-between pl-4 pr-2 text-left font-medium data-[placeholder]:font-normal data-[placeholder]:text-[#808080]")}>
                                                            <SelectValue placeholder={$t("Select your size")}/>
                                                        </SelectTrigger>
                                                    </FormControl>
                                                    <div className="absolute right-2 top-1/2 z-[1] flex -translate-y-1/2 items-center">
                                                        {(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.sku) ? (<button aria-label="Remove" type="button" onClick={() => {
                            field.onChange([
                                ...field.value.filter((i) => i.id !== ct.id),
                            ]);
                        }}>
                                                                <Cross height={20} width={20} className="opacity-50"/>
                                                            </button>) : (<SelectIcon asChild>
                                                                <ChevronDown height={20} width={20} aria-hidden="true" strokeWidth={2}/>
                                                            </SelectIcon>)}
                                                    </div>
                                                </div>
                                                <SelectContent position="popper" className="relative z-[100] max-h-[300px] min-w-[var(--radix-select-trigger-width)] overflow-hidden border border-gray-medium bg-white text-black data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1">
                                                    {skus.map((sku) => (<SelectItem className="relative w-full cursor-pointer select-none py-1.5 px-2 text-sm outline-none focus:bg-gray-bg data-[disabled]:text-gray-disabled" value={sku.sku} disabled={sku.disabled} key={sku.sku}>
                                                            <span className="inline-flex w-full items-center justify-between">
                                                                <span className="flex-1">{sku.size}</span>
                                                                {sku.disabled && (<span className="ml-2">{$t("Out of stock")}</span>)}
                                                            </span>
                                                        </SelectItem>))}
                                                </SelectContent>
                                            </Select>
                                        </FormItem>);
            }}/>
                            <button onClick={onFavorite} className="flex h-12 w-12 items-center justify-center border border-black" aria-label={lineItemId ? "Remove from wishlist" : "Add to wishlist"} type="button">
                                <Favorite width="32" height="32" className={cn("text-green-dark", lineItemId ? "fill-green-dark" : "fill-white")}/>
                            </button>
                        </>)}
                </div>
            </div>
        </div>);
};
